import * as BootstrapIcons from 'react-bootstrap-icons'

export const AgentInfoRow = ({
  iconName,
  label,
  value,
} : {
  iconName: string
  label: string
  value: string
}) => {
  const IconComponent = BootstrapIcons[iconName as keyof typeof BootstrapIcons]
  
  return (
    <div className='osirus-agent-info-row'>
      {IconComponent && <IconComponent />}
      <p><strong>{label}:</strong> {value}</p>
    </div>
  )
}
